import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true
});

// Attach Bearer token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lt_session");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, clear local session so user is redirected to /login next render
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login" && !window.location.hash.includes("session_id=")) {
        localStorage.removeItem("lt_session");
      }
    }
    return Promise.reject(err);
  }
);

export function setSession(token) {
  if (token) localStorage.setItem("lt_session", token);
  else localStorage.removeItem("lt_session");
}
